import styled from "styled-components";

export const Wrraper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0px 10px;
`;
export const Title = styled.h2`
  color: #835536;
`;

export const BtnHome = styled.a`
  padding: 10px;
  border-radius: 10px;
  background: var(
    --linear,
    linear-gradient(164deg, #5ed2d2 0%, #5ed2b7 58.45%)
  );

  box-shadow: 0px 4px 10px 0px rgba(95, 211, 183, 0.4);
  color: #fff !important;
  border: none;
  font-size: 14px;
  font-weight: 700;
  width: 200px;
  height: 46px;
  margin: 1rem 0rem;
  @media (max-width: 327px) {
    font-size: 12px;
    width: 80px;
  }
`;
